// extracted by mini-css-extract-plugin
export default {"editableCell":"styles_editableCell__7gCK6"};